import { render, staticRenderFns } from "./SourcingOrderInfo.vue?vue&type=template&id=3c8bd720&"
import script from "./SourcingOrderInfo.vue?vue&type=script&lang=js&"
export * from "./SourcingOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports